import { memo, useEffect, useLayoutEffect, useState } from "react";
import { ClipLoader } from "react-spinners";
import { BsCheck2Circle } from "react-icons/bs";
import { FDialog, FTypo } from "ferrum-design-system";
import {
  useAlgoSignerWalletConnector,
  useWalletConnector,
  useKeplrWalletConnector,
} from "foundry";
import { useDispatch, useSelector } from "react-redux";
import { ThemeProvider, createGlobalStyle } from "styled-components";
import { IS_MULTISWAP } from "../../utils/const.utils";
import { RootState } from "../../redux/rootReducer";
import * as walletActions from "../../redux/slices/wallet";
import * as networkActions from "../../redux/slices/network";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import { isMobile, browserName } from "react-device-detect";

export const ConnectWalletDialogMultiSwap = memo(
  ({
    show,
    onHide,
    metaMaskClickEvent,
    walletConnectClickEvent,
    zerionClickEvent,
    algorandWalletClickEvent,
    keplrWalletClickEvent,
    selectAlgorandWalletAddress,
    selectNetworkRPC,
  }: any) => {
    const dispatch = useDispatch();
    const queryParams = new URLSearchParams(window.location.search);
    const demoMode = Boolean(queryParams.get("demo"));
    const [termsAccepted, setTermsAccepted] = useState(false);
    const [networkSelected, setNetworkSelected] = useState(false);
    const { isConnected, isConnecting, currentWallet } = useWalletConnector();
    const { isAlgoConnected, isAlgoConnecting, walletAddresses } =
      useAlgoSignerWalletConnector();
    const { isKeplrConnected } = useKeplrWalletConnector();
    const {
      networksPayload: networks,
      selectedNetwork,
      theme,
      walletsPayload,
    } = useSelector((state: RootState) => ({
      ...state.networks,
      ...state.config,
      ...state.wallets,
    }));

    const responsive = {
      superLargeDesktop: {
        breakpoint: { max: 4000, min: 3000 },
        items: 6,
      },
      desktop: {
        breakpoint: { max: 3000, min: 1024 },
        items: 6,
      },
      tablet: {
        breakpoint: { max: 1024, min: 464 },
        items: 4,
      },
      mobile: {
        breakpoint: { max: 464, min: 0 },
        items: 3,
      },
    };

    const connectWalletHandler = (wallet: any) => {
      if (demoMode) {
        return;
      }
      if (wallet?.name === "MetaMask") {
        metaMaskClickEvent();
      } else if (wallet?.name === "Algorand") {
        algorandWalletClickEvent();
      } else if (wallet?.name === "Wallet Connect") {
        walletConnectClickEvent();
        onHide();
      } else if (wallet?.name === "Keplr") {
        keplrWalletClickEvent();
      } else if (wallet?.name === "Zerion") {
        zerionClickEvent();
      }
      dispatch(walletActions.setSelectedWallet(wallet));
    };

    const selectNetwork = (data: any) => {
      setNetworkSelected(true);
      selectNetworkRPC(data.rpcUrl);
      dispatch(networkActions.setSelectedNetwork({ selectedNetwork: data }));
      dispatch(walletActions.getWalletListByNetwork(data._id));
    };

    useEffect(() => {
      if (isAlgoConnected && walletAddresses && walletAddresses?.length) {
        selectAlgorandWalletAddress(walletAddresses[0]?.address);
      }
      // eslint-disable-next-line
    }, [walletAddresses]);

    const GlobalStyles = createGlobalStyle`
  .f-dialog-connect-wallet {
    .f-dialog {
      background-image: url(${theme?.dialogs?.crucibleModalConnectWallet}) !important;
    }
  }
    .f-dialog-main, .f-dialog {
      .f-dialog-content {
        .f-dialog-header {
          h3 {
            color: ${theme?.colors?.primary} !important;
          }
        }
      }
  }
  `;

    if (IS_MULTISWAP) {
      return (
        <div className="full-screen-mobile">
          <FDialog
            show={show}
            size={"large connectwalletimg-m"}
            onHide={onHide}
            variant={"connect-wallet connectwallet-m"}
            title="Connect Wallet"
            className={"f-mt-3 connect-wallet-no-margintop"}
          >
            <>
              <div className="connectwallet">
                <div className="ms-connect-wallet-dialog-step-1">
                  <FTypo
                    color={theme?.colors?.primary}
                    size={22}
                    className="ms-connect-wallet-dialog-step-1-heading"
                  >
                    STEP 1
                  </FTypo>
                  <FTypo color={theme?.colors?.primaryLight} className="f-pt-1">
                    <label>
                      <input
                        className="connect-wallet-dialog-checkbox cursor-pointer"
                        type="checkbox"
                        id="checked"
                        onClick={() => {
                          setNetworkSelected(false);
                          setTermsAccepted(!termsAccepted);
                        }}
                      />
                      <span className="checkmark">
                        I have read and accept the{" "}
                        <a
                          href="https://ferrum.network/terms-and-conditions/"
                          target="_blank"
                          style={{ color: "#d9b373" }}
                        >
                          Terms & Conditions
                        </a>
                      </span>
                    </label>
                  </FTypo>
                </div>
                <div className="ms-connect-wallet-dialog-step-2">
                  <FTypo
                    color={theme?.colors?.primary}
                    size={22}
                    className="ms-connect-wallet-dialog-step-2-heading"
                  >
                    STEP 2
                  </FTypo>
                  <FTypo color={theme?.colors?.primaryLight}>
                    Choose Network
                  </FTypo>
                  <div className="network-selection f-mt-1 f-mb-1 ms-connect-wallet-dialog-step-2-networks-mobile">
                    <Carousel responsive={responsive}>
                      {networks.map((item: any, index: any) => {
                        return (
                          <div
                            className={`text-center f-pt--3 connect-wallet-dialog-network ${item?.name?.trim()} ${
                              !termsAccepted
                                ? "ms-disable-pointers"
                                : "cursor-pointer"
                            }`}
                            onClick={() => selectNetwork(item)}
                            key={index}
                          >
                            <img
                              className={`ms-network-logo  ${
                                !termsAccepted ? "ms-disable-image" : ""
                              } ${
                                selectedNetwork?._id === item._id &&
                                networkSelected
                                  ? "ms-network-logo-selected"
                                  : ""
                              }`}
                              src={item.logo}
                              alt={item.name}
                            />
                            {networkSelected &&
                            selectedNetwork?._id === item._id ? (
                              <BsCheck2Circle
                                color="#DAB46E"
                                style={{
                                  position: "relative",
                                  bottom: "30px",
                                  right: "10px",
                                  borderRadius: "50%",
                                  backgroundColor: "black",
                                }}
                              />
                            ) : (
                              ""
                            )}
                            <FTypo
                              color={
                                !termsAccepted
                                  ? theme?.colors?.backgroundLight
                                  : theme?.colors?.primaryLight
                              }
                              size={13}
                              // className={`${
                              //   !termsAccepted ? "ms-disable-text" : ""
                              // }`}
                            >
                              {item.name}
                            </FTypo>
                          </div>
                        );
                      })}
                    </Carousel>
                  </div>
                </div>
                <div className="ms-connect-wallet-dialog-step-2 f-mt--5">
                  <FTypo
                    color={theme?.colors?.primary}
                    className="ms-connect-wallet-dialog-step-2-heading f-pt--1"
                  >
                    STEP 3
                  </FTypo>
                  <FTypo color={theme?.colors?.primaryLight}>
                    Choose Wallets
                  </FTypo>
                  <div className="network-selection f-mt-1">
                    <Carousel responsive={responsive}>
                      {walletsPayload?.map((item: any) => {
                        return (
                          <div
                            className={`text-center ${
                              !networkSelected
                                ? "ms-disable-pointers"
                                : "cursor-pointer"
                            }`}
                            onClick={() => connectWalletHandler(item.wallet)}
                            id={item?._id}
                          >
                            <div
                              className={`connect-wallet-dialog-wallet ${item?.wallet?.name?.trim()}`}
                            >
                              {networkSelected &&
                              ((item.name === "Meta Mask" && isConnecting) ||
                                (item.name === "Algorand" &&
                                  isAlgoConnecting)) ? (
                                <ClipLoader
                                  color="#cba461"
                                  loading={true}
                                  size={30}
                                />
                              ) : (
                                <>
                                  <img
                                    className={`ms-network-logo ${
                                      !networkSelected ? "ms-disable-image" : ""
                                    } ${
                                      isConnected &&
                                      currentWallet === "MetaMask" &&
                                      item.wallet.name === "MetaMask"
                                        ? "ms-network-logo-selected"
                                        : isAlgoConnected &&
                                          item.wallet.name === "Algorand"
                                        ? "ms-network-logo-selected"
                                        : isConnected &&
                                          currentWallet === "WalletConnect" &&
                                          item.wallet.name === "MetaMask"
                                        ? "ms-network-logo-selected"
                                        : isKeplrConnected &&
                                          item.wallet.name === "Keplr"
                                        ? "ms-network-logo-selected"
                                        : ""
                                    }`}
                                    src={item.wallet.logo}
                                    alt={item.wallet.name}
                                  />
                                  {isConnected &&
                                  currentWallet === "MetaMask" &&
                                  item.wallet.name === "MetaMask" ? (
                                    <BsCheck2Circle
                                      color="#DAB46E"
                                      style={{
                                        position: "relative",
                                        bottom: "26px",
                                        right: "7px",
                                        borderRadius: "50%",
                                        backgroundColor: "black",
                                      }}
                                      className="ms-selected-wallet"
                                    />
                                  ) : isAlgoConnected &&
                                    item.name === "Algorand" ? (
                                    <BsCheck2Circle
                                      color="#DAB46E"
                                      style={{
                                        position: "relative",
                                        bottom: "26px",
                                        right: "7px",
                                        borderRadius: "50%",
                                        backgroundColor: "black",
                                      }}
                                      className="ms-selected-wallet"
                                    />
                                  ) : isConnected &&
                                    currentWallet === "WalletConnect" &&
                                    item.wallet.name === "MetaMask" ? (
                                    <BsCheck2Circle
                                      color="#DAB46E"
                                      style={{
                                        position: "relative",
                                        bottom: "26px",
                                        right: "7px",
                                        borderRadius: "50%",
                                        backgroundColor: "black",
                                      }}
                                      className="ms-selected-wallet"
                                    />
                                  ) : isKeplrConnected &&
                                    item.wallet.name === "Keplr" ? (
                                    <BsCheck2Circle
                                      color="#DAB46E"
                                      style={{
                                        position: "relative",
                                        bottom: "26px",
                                        right: "7px",
                                        borderRadius: "50%",
                                        backgroundColor: "black",
                                      }}
                                      className="ms-selected-wallet"
                                    />
                                  ) : null}
                                </>
                              )}
                              <FTypo
                                size={13}
                                color={`${
                                  !networkSelected
                                    ? theme?.colors?.backgroundLight
                                    : theme?.colors?.primaryLight
                                }`}
                              >
                                {item.wallet.name}
                              </FTypo>
                            </div>
                          </div>
                        );
                      })}
                    </Carousel>
                  </div>
                </div>
              </div>
            </>
          </FDialog>
        </div>
      );
    } else {
      const getAllowedNetworks = () => {
        if ((theme.crucibleConfig?.crucibleFarms || []).length) {
          const reMappedNetworks = { ARBITRUM: "Arbitrum One" };
          const allowedNetworks = theme.crucibleConfig?.crucibleFarms.map(
            (e: any) =>
              reMappedNetworks[e.network as keyof typeof reMappedNetworks] ||
              e.network
          );
          const filteredNetworks = networks.filter((network: any) =>
            allowedNetworks.includes(network.name)
          );
          return filteredNetworks;
        }
        return networks;
      };

      return (
        <ThemeProvider theme={theme}>
          <FDialog
            show={show}
            size={"large"}
            onHide={onHide}
            variant={"connect-wallet"}
            title="Connect Wallet"
            className={"f-mt-3"}
          >
            <>
              <div className="connectwallet">
                <div className="ms-connect-wallet-dialog-step-1">
                  <FTypo
                    color={theme?.colors?.primary}
                    size={22}
                    className="ms-connect-wallet-dialog-step-1-heading"
                  >
                    STEP 1
                  </FTypo>
                  <FTypo
                    color={theme?.colors?.primaryLight}
                    className="accept-terms"
                  >
                    Accept Terms of Service and Privacy Policy
                  </FTypo>
                  <FTypo color={theme?.colors?.primaryLight} className="f-pt-1">
                    <label>
                      <input
                        type="checkbox"
                        id="checked"
                        onClick={() => {
                          setNetworkSelected(false);
                          setTermsAccepted(!termsAccepted);
                        }}
                      />
                      <span className="checkmark">I read and accept</span>
                    </label>
                  </FTypo>
                </div>
                <div className="ms-connect-wallet-dialog-step-2">
                  <FTypo
                    color={theme?.colors?.primary}
                    size={22}
                    className="ms-connect-wallet-dialog-step-2-heading"
                  >
                    STEP 2
                  </FTypo>
                  <FTypo color={theme?.colors?.primaryLight}>
                    Choose Network
                  </FTypo>
                  <div className="network-selection f-mt-1 f-mb-1 ms-connect-wallet-dialog-step-2-networks-mobile">
                    <Carousel responsive={responsive}>
                      {getAllowedNetworks().map((item: any, index: any) => {
                        return (
                          <div
                            className={`text-center f-pt--3 ${
                              !termsAccepted ? "ms-disable-pointers" : ""
                            }`}
                            onClick={() => selectNetwork(item)}
                            key={index}
                          >
                            <img
                              className={`ms-network-logo  ${
                                !termsAccepted ? "ms-disable-image" : ""
                              } ${
                                selectedNetwork?._id === item._id &&
                                networkSelected
                                  ? "ms-network-logo-selected"
                                  : ""
                              }`}
                              src={item.logo}
                              alt={item.name}
                            />
                            {networkSelected &&
                            selectedNetwork?._id === item._id ? (
                              <BsCheck2Circle
                                color="#DAB46E"
                                style={{
                                  position: "relative",
                                  bottom: "30px",
                                  right: "10px",
                                  backgroundColor: "black",
                                }}
                              />
                            ) : (
                              ""
                            )}
                            <FTypo
                              color={
                                !termsAccepted
                                  ? theme?.colors?.backgroundLight
                                  : theme?.colors?.primaryLight
                              }
                              size={13}
                              // className={`${
                              //   !termsAccepted ? "ms-disable-text" : ""
                              // }`}
                            >
                              {item.name}
                            </FTypo>
                          </div>
                        );
                      })}
                    </Carousel>
                  </div>
                </div>
                <div className="ms-connect-wallet-dialog-step-2 f-mt--5">
                  <FTypo
                    color={theme?.colors?.primary}
                    className="ms-connect-wallet-dialog-step-2-heading f-pt--1"
                  >
                    STEP 3
                  </FTypo>
                  <FTypo color={theme?.colors?.primaryLight}>
                    Choose Wallets
                  </FTypo>
                  <div className="network-selection f-mt-1">
                    <Carousel responsive={responsive}>
                      {walletsPayload?.map((item: any) => {
                        return (
                          <div
                            className={`text-center ${
                              !networkSelected ? "ms-disable-pointers" : ""
                            }`}
                            onClick={() => connectWalletHandler(item.wallet)}
                            id={item?._id}
                          >
                            <div>
                              {networkSelected &&
                              ((item.name === "Meta Mask" && isConnecting) ||
                                (item.name === "Algorand" &&
                                  isAlgoConnecting)) ? (
                                <ClipLoader
                                  color="#cba461"
                                  loading={true}
                                  size={30}
                                />
                              ) : (
                                <>
                                  <img
                                    className={`ms-network-logo ${
                                      !networkSelected ? "ms-disable-image" : ""
                                    } ${
                                      isConnected &&
                                      currentWallet === "MetaMask" &&
                                      item.wallet.name === "MetaMask"
                                        ? "ms-network-logo-selected"
                                        : isAlgoConnected &&
                                          item.wallet.name === "Algorand"
                                        ? "ms-network-logo-selected"
                                        : isConnected &&
                                          currentWallet === "WalletConnect" &&
                                          item.wallet.name === "MetaMask"
                                        ? "ms-network-logo-selected"
                                        : isKeplrConnected &&
                                          item.wallet.name === "Keplr"
                                        ? "ms-network-logo-selected"
                                        : ""
                                    }`}
                                    src={item.wallet.logo}
                                    alt={item.wallet.name}
                                  />
                                  {isConnected &&
                                  currentWallet === "MetaMask" &&
                                  item.wallet.name === "MetaMask" ? (
                                    <BsCheck2Circle
                                      color="#DAB46E"
                                      style={{
                                        position: "relative",
                                        bottom: "26px",
                                        right: "7px",
                                        backgroundColor: "black",
                                      }}
                                      className="ms-selected-wallet"
                                    />
                                  ) : isAlgoConnected &&
                                    item.name === "Algorand" ? (
                                    <BsCheck2Circle
                                      color="#DAB46E"
                                      style={{
                                        position: "relative",
                                        bottom: "26px",
                                        right: "7px",
                                        backgroundColor: "black",
                                      }}
                                      className="ms-selected-wallet"
                                    />
                                  ) : isConnected &&
                                    currentWallet === "WalletConnect" &&
                                    item.wallet.name === "MetaMask" ? (
                                    <BsCheck2Circle
                                      color="#DAB46E"
                                      style={{
                                        position: "relative",
                                        bottom: "26px",
                                        right: "7px",
                                        backgroundColor: "black",
                                      }}
                                      className="ms-selected-wallet"
                                    />
                                  ) : isKeplrConnected &&
                                    item.wallet.name === "Keplr" ? (
                                    <BsCheck2Circle
                                      color="#DAB46E"
                                      style={{
                                        position: "relative",
                                        bottom: "26px",
                                        right: "7px",
                                        backgroundColor: "black",
                                      }}
                                      className="ms-selected-wallet"
                                    />
                                  ) : null}
                                </>
                              )}
                              <FTypo
                                size={13}
                                color={`${
                                  !networkSelected
                                    ? theme?.colors?.backgroundLight
                                    : theme?.colors?.primaryLight
                                }`}
                              >
                                {item.wallet.name}
                              </FTypo>
                            </div>
                          </div>
                        );
                      })}
                    </Carousel>
                  </div>
                </div>
              </div>
            </>
          </FDialog>
          <GlobalStyles />
        </ThemeProvider>
      );
    }
  }
);
